<template>
  <v-btn
    v-if="allowed"
    icon
    class="mr-2"
    title="Hall enquiries"
    @click="open"
  >
    <v-badge color="red" :content="String(count)" :value="count > 0" overlap>
      <v-icon>mdi-bell</v-icon>
    </v-badge>
  </v-btn>
</template>

<script>
import http from "@/plugins/axios";

export default {
  data: () => ({
    count: 0,
    allowed: false,
    timer: null,
  }),
  created() {
    this.refresh();
    this.timer = setInterval(this.refresh, 20000);
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },
  methods: {
    canSee() {
      const policies = this.$store.state.user.policies || [];
      return policies.some((policy) => {
        const name = typeof policy === "string" ? policy : policy && policy.name;
        return name === "Website Banquet Hall Index";
      });
    },
    refresh() {
      if (!this.canSee()) {
        this.allowed = false;
        this.count = 0;
        return;
      }
      this.allowed = true;
      http
        .get("hms/hall-enquiries/unread")
        .then((res) => {
          this.count = Number(res.data && res.data.count) || 0;
        })
        .catch(() => {});
    },
    open() {
      this.count = 0;
      http.post("hms/hall-enquiries/seen").catch(() => {});
      if (this.$route.path === "/website/hall-enquiries") {
        this.$root.$emit("hall-enquiries-refresh");
        return;
      }
      this.$router.push("/website/hall-enquiries");
    },
  },
};
</script>
